var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{staticStyle:{"position":"relative","height":"91vh","width":"100%"},attrs:{"src":_vm.lay,"scrolling":"no","frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }